import { Message } from 'element-ui'

let messagesSet = new Set()

const uniqueMessage = function (options) {
  const messageKey = JSON.stringify(options)

  if (!messagesSet.has(messageKey)) {
    Message({
      ...options,
      onClose() {
        messagesSet.delete(messageKey)
      },
    })
    messagesSet.add(messageKey)
  }
}

const messageMixin = {
  methods: {
    $uniqueMessage(options) {
      uniqueMessage(options)
    },
  },
}

export { uniqueMessage, messageMixin }
